import React from 'react';
import { DataGrid } from '../../common/datagrid/ResponsiveDataGrid';
import CustomLoadingOverlay from '../../common/datagrid/CustomLoadingOverlay';
import CustomToolbar from '../../common/datagrid/CustomToolbar';

const TechList = ({ columns, rows, loading,handleRowClick,columnVisibilityModel}) => {
  return (
    <div style={{ display: 'flex', height: '350px' }}>
      <div style={{ flexGrow: 1 }}>
        <DataGrid
          rows={rows ? rows : []}
          columns={columns}
          components={{
            Toolbar: CustomToolbar,
            LoadingOverlay: CustomLoadingOverlay,
          }}
          componentsProps={{
            toolbar: { fileName: '프로젝트_지원리스트' },
          }}
          loading={loading}
          onRowClick={handleRowClick}
          columnVisibilityModel={columnVisibilityModel? columnVisibilityModel: []}
/>
      </div>
    </div>
  );
};

export default TechList;
